import {useAppInsightsContext} from "@microsoft/applicationinsights-react-js";

export const useTrackPageView = (pageName) => {
    const context = useAppInsightsContext();

    context.trackPageView({
        name: pageName
    })
}